
/* Tooltip */
.vs-tooltip {
  display: inline-block;
  position: relative;
  text-align: left;
  top: 0 !important;
}
.vs-tooltip-dialog {
  min-width: 300px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 10px;
  color: var(--tertiary-4-color);
  background-color: #fff;
  font-weight: normal;
  font-size: 13px;
  position: fixed;
  z-index: 9;
  box-sizing: border-box;
  border: 1px solid var(--tertiary-4-color);
  box-shadow: 0 1px 8px var(--tertiary-4-color);
  display: none;
  width: 80vw;
}
.vs-tooltip-dialog .vs-lead {
  margin-right: 20px;
}
.vs-tooltip-dialog .vs-lead:focus-visible {
  outline: none;
}
.vs-tooltip-dialog i {
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -12px;
  width: 24px;
  height: 12px;
  overflow: hidden;
}
@media (min-width: 768px) {
  .vs-tooltip-dialog i.vs-top-left {
    top: -12px;
    left: 15px;
  }
  .vs-tooltip-dialog i.vs-top-left::after {
    transform: translate(-50%, 50%) rotate(45deg);
  }
  .vs-tooltip-dialog i.vs-top-right {
    top: -12px;
    right: 2px;
    left: auto;
  }
  .vs-tooltip-dialog i.vs-top-right::after {
    transform: translate(-50%, 50%) rotate(45deg);
  }
  .vs-tooltip-dialog i.vs-top-center {
    top: -12px;
  }
  .vs-tooltip-dialog i.vs-top-center::after {
    transform: translate(-50%, 50%) rotate(45deg);
  }
  .vs-tooltip-dialog i.vs-bottom-left {
    bottom: 12px;
    left: 15px;
  }
  .vs-tooltip-dialog i.vs-bottom-right {
    bottom: -12px;
    right: 2px;
    left: auto;
  }
}
@media (min-width: 768px) {
  .vs-tooltip-dialog {
    min-width: 400px;
    position: absolute;
    top: auto;
    left: auto;
    transform: none;
    width: auto;
  }
  .vs-tooltip-dialog i::after {
    content: '';
    position: absolute;
    width: 12px;
    height: 12px;
    left: 50%;
    transform: translate(-50%, -50%) rotate(45deg);
    background-color: #fff;
    border: 1px solid var(--tertiary-4-color);
    box-shadow: 0 1px 8px var(--tertiary-4-color);
  }
}
.vs-tooltip-background {
  background: var(--tertiary-6-color);
  opacity: 0.5;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 8;
}
@media (min-width: 768px) {
  .vs-tooltip-background {
    display: none;
  }
}
.vs-close {
  border: 0;
  background: transparent;
  color: var(--tertiary-7-color);
  float: right;
  font-family: 'visa-icon';
  font-size: 20px;
  padding: 5px;
  position: absolute;
  top: 4px;
  right: 4px;
}
.vs-close:hover, .vs-close:focus {
  cursor: pointer;
  outline: 1px dashed var(--tertiary-6-color);
}
.vs-close::before {
  content: '\e810';
}
.visa-icon {
  background: #fff;
  border: 0;
  cursor: pointer;
  font-family: 'visa-icon';
  font-size: 30px;
  line-height: 100%;
}
.visa-icon:hover, .visa-icon:focus {
  cursor: pointer;
  outline: 1px dashed var(--tertiary-6-color);
}
.visa-icon-info {
  margin: 0 5px;
  padding: 0 5px;
}
.visa-icon-info:before {
  content: "\e821";
}
[dir=rtl] .vs-tooltip {
  text-align: right;
}
[dir=rtl] .vs-lead {
  margin-left: 20px;
  margin-right: 0;
}
[dir=rtl] .vs-close {
  left: 4px;
  right: auto;
  float: left;
}
